// extracted by mini-css-extract-plugin
export var table = "_xg-0";